<template>
  <div class="advertisingGroup">
    <header class="advertisingGroup_header">
      <el-button
        type="primary"
        style="margin-right: 100px;"
        @click="$refs.addWechatUser.open(0, 1)"
      >添加</el-button>
      <el-input
        v-model="wechatUsersQuery.wechat_name"
        placeholder="公众号名称"
        style="width: 200px; margin-right: 10px;"
      />
      <el-input
        v-model="wechatUsersQuery.advertiser_account"
        placeholder="广告主名称"
        style="width: 200px; margin-right: 10px;"
      />
      <el-button
        type="primary"
        style="margin-right: 5px"
        icon="el-icon-search"
        @click="handleSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="handleReset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        :key="key"
        v-loading="loading"
        :data="list"
        row-key="id"
        style="width: 100%"
      >
        <!-- <el-table-column
          type="expand"
          width="50"
          label="详情"
        >
          <template scope="scope">
            <div v-for="(item,index) in scope.row" :key="index">
              <div v-if="index !== 0" class="detail-row">
                <div class="left-box" />
                <div class="detail-left">
                  <p>{{ `${item.advertiser_name}&nbsp;(${item.advertiser_account_id})` }}</p>
                  <span>{{ item.start_time }}</span>--
                  <span>{{ item.end_time }}</span>
                </div>
                <div class="detail-right">
                  <el-button
                    size="mini"
                    @click="$refs.modifyWechatUser.open(item)"
                  >修改</el-button>
                </div>
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="app_id"
          label="Appid"
        />
        <el-table-column
          prop="wechat_name"
          label="公众号"
        />
        <el-table-column
          prop="advertiser_name"
          label="分配详情"
        >
          <template scope="scope">
            <div>
              <span>{{ scope.row.advertiser_name }}</span>
              <div>
                <span>{{ scope.row.start_time }}</span>
                --
                <span>{{ scope.row.end_time }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          total
          @current-change="handleReset"
        >
          <template scope="scope">
            <el-button
              v-if="scope.row.children"
              type="primary"
              size="mini"
              @click="$refs.addWechatUser.open(scope.row, 2)"
            >添加</el-button>
            <el-button
              size="mini"
              @click="$refs.modifyWechatUser.open(scope.row)"
            >修改</el-button>
            <el-button
              v-if="scope.row.children"
              size="mini"
              @click="openHistoryDialog(scope.row)"
            >历史</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <AddWechatUser
      ref="addWechatUser"
      :select-data="tableData"
      :option1="{
        label:'account_name',
        value:'account_id',
        title:'广告主'
      }"
      @confirm="addUserConfirm"
    />
    <ModifyWechatUser
      ref="modifyWechatUser"
      title="修改"
      option="广告主"
      @confirm="modifyConfirm"
    />
    <HistoryWechatUserData
      ref="historyWechatUserData"
      disable="昵称"
    />
    <PaginationRight
      :total="total"
      @current-change="fetchCurrentPage"
      @size-change="changePageSize"
    />
  </div>
</template>

<script>
import { getHistoricalRecords, modifyAdvertiser, addAdvertiser, getAdvertiserList } from '@/api/report/wechatGroup.js'
import AddWechatUser from './components/wechatGroup/AddWechatUser.vue'
import ModifyWechatUser from './components/wechatGroup/ModifyWechatUser.vue'
import HistoryWechatUserData from './components/wechatGroup/HistoryWechatUserData.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'PublicAdvertiserList',
  components: {
    AddWechatUser,
    ModifyWechatUser,
    HistoryWechatUserData,
    PaginationRight
  },
  data() {
    return {
      list: [],
      tableData: {},
      total: null,
      // wechatUsersQuery: {
      //   wechat_name: '',
      //   advertiser_account: ''
      // },
      wechatUsersQuery: {
        wechat_name: null,
        advertiser_account: null,
        page: 1,
        page_size: 10
      },
      loading: false,
      key: null
      // listData: []
    }
  },
  created() {
    // this.myGetAdvertiserList()
    this.getAdvertiserList()
  },
  methods: {
    async addUserConfirm(data) {
      let advertiser_id = null
      this.tableData.userList.forEach(item => {
        if (data.user_id === item.account_id) {
          advertiser_id = item.id
        }
      })
      delete data.user_id
      data.advertiser_id = advertiser_id
      await addAdvertiser(data)
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.getAdvertiserList()
    },
    // 打开历史弹窗
    async openHistoryDialog(value) {
      const data = await getHistoricalRecords(value.id)
      this.$refs.historyWechatUserData.open(data.data)
    },
    getAdvertiserList() {
      this.loading = true
      this.list = []
      getAdvertiserList(this.wechatUsersQuery).then(res => {
        if (res.data.list) {
          for (let i = 0; i < res.data.list.length; i++) {
            this.list[i] = res.data.list[i][0]
            this.list[i].children = []
            for (let j = 0; j < res.data.list[i].length; j++) {
              if (res.data.list[i][j + 1]) {
                this.list[i].children[j] = res.data.list[i][j + 1]
              }
            }
          }
        }
        console.log(this.list)
        this.tableData.auth_wechat = res.data.auth_wechat
        this.tableData.userList = res.data.auth_advertiser
        this.total = res.data.total
        this.key = Math.random()
        this.loading = false
      })
    },
    handleSearch() {
      this.getAdvertiserList()
    },
    handleReset() {
      this.wechatUsersQuery = {}
      this.getAdvertiserList()
    },
    fetchCurrentPage(e) {
      this.wechatUsersQuery.page = e
      this.getAdvertiserList()
    },
    changePageSize(e) {
      this.wechatUsersQuery.page_size = e
      this.getAdvertiserList()
    },
    async modifyConfirm(id, data) {
      await modifyAdvertiser(id, data)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getAdvertiserList()
    }
  }
}
</script>
<style scoped lang="less">
.advertisingGroup {
  min-width: 1200px;
  padding: 30px 60px;
  .advertisingGroup_header {
    margin-bottom: 20px;
  }
  .detail-row {
    display: flex;
    justify-content: right;
    margin-bottom: 20px;
    margin-right: 200px;
    .left-box {
      min-width: 400px;
    }
  }
  .detail-left {
    width: 200px;
    .detail-detail {
      text-align: center;
    }
    p {
      // text-align: center;
      padding-bottom: 10px;
    }
  }
  .detail-right {
    margin-left: 240px;
    .detail-handle {
      text-align: center;
    }
  }
}
</style>
